import { render } from "./Chatbot.vue?vue&type=template&id=de4d1fdc&scoped=true"
import script from "./Chatbot.vue?vue&type=script&lang=js"
export * from "./Chatbot.vue?vue&type=script&lang=js"

import "./Chatbot.vue?vue&type=style&index=0&id=de4d1fdc&lang=css"
import "./Chatbot.vue?vue&type=style&index=1&id=de4d1fdc&scoped=true&lang=css"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de4d1fdc"]])

export default __exports__